exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".email_status{\r\n  border: #3e2c42!important;\r\n  background: #f3bac0!important;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/padriana/gorent-panel/src/app/dashboard/user/user-info.component.css
// module id = ../../../../../src/app/dashboard/user/user-info.component.css
// module chunks = main